import { useQuery } from 'react-query';
import { DEALERS_API } from 'apis/Dealers/dealer';

export const DEALERS_LIST_CACHE_KEY = 'dealersList';

export const useDealersList = () =>
  useQuery(DEALERS_LIST_CACHE_KEY, DEALERS_API.fetch);
